import { Button, Col, Form, Input, message, Row } from 'antd';
import {useSelector} from 'react-redux';
import {v4 as uuid} from 'uuid';
import {RootState} from '@/store';
import Utils from '@/utils/utils';
import ResizeWrapper from '@/components/ResizeWrapper';
import BubbleMsg from '@/components/BubbleMsg';
import RippleWave from '@/components/RippleWave';
import {useJoin} from '../../lib/useCommon';

import MagicTools from '@/assets/img/magicTool.svg';
import DouBao from '@/assets/img/user_cyber.png';
import styles from './index.module.less';
import Config from '@/config';
import {CalendarPickerView, Dialog, List, NavBar, Popup} from 'antd-mobile';
import React, {useEffect, useState} from 'react';
import { AddOutline, CalendarOutline, CloseOutline, DeleteOutline } from 'antd-mobile-icons';
import { post } from '@/utils/request';
import {useNavigate} from "react-router-dom";

export interface FormProps {
  username: string;
  roomId: string;
}

export default function () {

  const navigate = useNavigate();
  const [popupVisible, setPopupVisible] = useState(false);

  /**
   * 初始化历史日历
   */
  const [dateList, setDateList] = useState<any>([]);
  const [dateMin, setDateMin] = useState<Date>();
  const [dateMax, setDateMax] = useState<Date>();
  const initHistoryCalendar = () => {
    //日期列表
    post("/cbc/history/list/date",{}).then((res)=>{
      let dateList = res.data;
      setDateList(dateList);
      if(dateList && dateList.length > 0){
        setDateMin(new Date(dateList[0]))
        setDateMax(new Date(dateList[dateList.length - 1]))
      }
    })
  }

  /**
   * 时间选中
   */
  const [currentDate, setCurrentDate] = useState<Date>();
  const [conversationList, setConversationList] = useState<any>([]);
  const onDateChoose  = (date:any) => {
    setCurrentDate(date);
    console.log(date)
    //日期列表
    console.log(date.toISOString().substring(0, 10))
    post("/cbc/history/list/by-date",{
      date: date.toISOString().substring(0, 10)
    }).then((res)=>{
      console.log(res);
      setConversationList(res.data);
    })
  }

  const clearAll  = () => {
    Dialog.show({
      title: '确认删除所有记录吗？',
      content: '确认后，所有记录将会消失，不可恢复。',
      closeOnAction: true,
      actions: [
        [
          {
            key: 'cancel',
            text: '取消',
          },
          {
            key: 'delete',
            text: '确认删除',
            bold: true,
            danger: true,
            onClick: ()=>{
              post("/cbc/history/deleteAll",{}).then((res)=>{
                if(res.code === 200){
                  setPopupVisible(false);
                  initHistoryCalendar();
                }else{
                  message.error(res.msg)
                }
              })
            }
          },
        ],
      ],
    })
  }

  useEffect(() => {
    //初始化历史日历
    initHistoryCalendar();
  }, []);

  return (
    <ResizeWrapper className={styles.container}>
      <NavBar
        className={styles.navBar}
        style={{height: 65}}
        // children={<div className={styles.navBarTitle}>咨询历史</div>}
        children={<img src={require('@/assets/img/his_1.jpg')} style={{ height: 35 }} alt="" />}
        backIcon={<img src={require('@/assets/img/menu.png')} style={{height: 25}}/>}
        onBack={() => {
          setPopupVisible(true);
        }}
      />

      {/*日历*/}
      <div className={styles.calendarContainer}>
        <CalendarPickerView
          min={dateMin}
          max={dateMax}
          title={false}
          selectionMode="single"
          onChange={onDateChoose}
          renderDate={(date: Date) => {
            return <>
              <div className={currentDate?.getDate() === date.getDate() ?`${styles.dateItem} ${styles.dateItemActive}`:`${styles.dateItem}`}>
                <div>{date.getDate()}</div>
                {
                  dateList && date && dateList.includes(date.toISOString().substring(0, 10)) &&
                  <div className={styles.point}></div>
                }
              </div>
            </>
          }} />
      </div>

      <div className={styles.conversationContainer}>

        {
          conversationList && conversationList.map((item:any)=>{
            return <>
              <div className={styles.conversation} onClick={()=>{navigate(`/history/summary?conversationId=${item.id}`)}}>
                <Row>
                  <Col span={4} className={styles.time}>
                    {item.createTime && item.createTime.substring(11,16)}
                  </Col>
                  <Col span={18} className={styles.title}>
                    {item.title}
                  </Col>
                  <Col span={1} className={styles.array}>
                    <img src={require('@/assets/array_right.png')} />
                  </Col>
                </Row>
              </div>
            </>
          })
        }
      </div>

      <Popup
        visible={popupVisible}
        onMaskClick={() => {
          setPopupVisible(false);
        }}
        position="left"
        bodyStyle={{width: '60vw'}}
      >
        <div className={styles.popupContent}>
          <List header="">
            <List.Item prefix={<AddOutline/>} arrowIcon={false} onClick={() => {
              navigate('/router');
            }}>
              开启新对话
            </List.Item>
            <List.Item prefix={<DeleteOutline/>} arrowIcon={false} onClick={() => {
              clearAll();
            }} className={styles.clear}>
              清除所有记录
            </List.Item>
          </List>
        </div>
      </Popup>
    </ResizeWrapper>
  );
}
